import React from "react";
import { PlaceOrderForm } from "../shared/PlaceOrderForm";
import { usePlaceOrder } from "../../hooks/usePlaceOrder";

export function PlaceOrder({
  onPlaceOrder,
  onSubmit,
  checkoutSummary,
  formValues,
  onChange,
  onCancel,
  onBack,
  readOnly,
  className,
  captchaRef,
  paymentContainerId,
}) {
  const {
    placeOrder,
    loading,
    paymentBlocked,
    onPaymentSuccess,
    onPaymentError,
    onValidationChange,
    onSubmitAvailable,
  } = usePlaceOrder({
    onPlaceOrder,
    onSubmit,
    checkoutSummary,
    formValues,
  });

  return (
    <div className="checkout-place-order">
      <PlaceOrderForm
        variant="checkout"
        onSubmit={placeOrder}
        className={className}
        checkoutSummary={checkoutSummary}
        formValues={formValues}
        onChange={onChange}
        readOnly={readOnly}
        loading={loading}
        paymentBlocked={paymentBlocked}
        onPaymentSuccess={onPaymentSuccess}
        onPaymentError={onPaymentError}
        onValidationChange={onValidationChange}
        onSubmitAvailable={onSubmitAvailable}
        onCancel={onCancel}
        onBack={onBack}
        captchaRef={captchaRef}
        paymentContainerId={paymentContainerId}
      />
    </div>
  );
}
